import { createWebHistory, createRouter } from 'vue-router'
import MainComponent from '@/components/MainComponent'

export default createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'MainComponent', component: MainComponent }
  ]
})
